import React from 'react';
import DialogHeaderControl from '../dialog-header-control';
import ActionButton from '../../../action-button';
import { APPEARANCES, SIZES, FORMATS } from '../../../action-button/constants';

const DialogHeaderActionButton = (props) => (
  <DialogHeaderControl>
    <ActionButton
      {...props}
      appearance={APPEARANCES.default}
      size={SIZES.medium}
      format={FORMATS.text}
    />
  </DialogHeaderControl>
);

export default DialogHeaderActionButton;
